export default {
  formId: 'checkoutForm',
  formField: {
    firstName: {
      name: 'firstName',
      label: 'Nome completo*',
      requiredErrorMsg: 'O nome completo é obrigatório'
    },
    lastName: {
      name: 'lastName',
      label: 'Last name*',
      requiredErrorMsg: 'Last name is required'
    },
    address1: {
      name: 'address2',
      label: 'Endereço*',
      requiredErrorMsg: 'O Endereço é obrigatório'
    },

    city: {
      name: 'city',
      label: 'Cidade*',
      requiredErrorMsg: 'Cidade é obrigatória'
    },
    state: {
      name: 'state',
      label: 'Estado*',
      requiredErrorMsg: 'Cidade é obrigatória'
    },
    zipcode: {
      name: 'zipcode',
      label: 'CPF/CNPJ*',
      requiredErrorMsg: 'CEP é obrigatório',
      invalidErrorMsg: 'Formato de CEP inválido'
    },
    country: {
      name: 'country',
      label: 'País*',
      requiredErrorMsg: 'País é obrigatório'
    },
    useAddressForPaymentDetails: {
      name: 'useAddressForPaymentDetails',
      label: 'Use this address for payment details'
    },
    phone: {
      name: 'phone',
      label: 'Telefone / WhatsApp*',
      requiredErrorMsg: 'Telefone e obrigatorio'
    },
    addressNumber: {
      name: 'addressNumber',
      label: 'Numero',
    },
    addressNeighborhood: {
      name: 'addressNeighborhood',
      label: 'Bairro',
    },
    addressZipCode: {
      name: 'addressZipCode',
      label: 'CEP',
    },
    emailBilling: {
      name: 'email',
      label: 'E-mail*',
      requiredErrorMsg: 'E-mail e obrigatorio'
    }
  }
};
